import { Injectable, inject } from '@angular/core'
import { TranslateService } from '@ngx-translate/core'
import { ToastrService } from 'ngx-toastr'
import { PrimeNG } from 'primeng/config'

/** Viewport where the admin shell switches to the mobile layout (drawer menu). */
export const MOBILE_LAYOUT_QUERY = '(max-width: 1024px)'

@Injectable({
  providedIn: 'root',
})
export class SharedService {
  private toastr = inject(ToastrService)
  private translate = inject(TranslateService)
  private primeNG = inject(PrimeNG)

  direction: any
  language: any = 'ar'
  // Closed by default on mobile so the drawer never opens over the first page.
  isOpenMenu = typeof window === 'undefined' || !(window.matchMedia?.(MOBILE_LAYOUT_QUERY)?.matches ?? false)

  showSuccess(message: string) {
    this.toastr.success(message)
  }

  showError(message: string) {
    this.toastr.error(message)
  }

  setLangSettings(lang: string): void {
    this.direction = lang !== 'ar' ? 'ltr' : 'rtl'
    this.language = lang
    this.translate.setDefaultLang(lang)
    this.translate.use(lang)
    document.documentElement.setAttribute('dir', this.direction)

    this.translate.get('primeng').subscribe((translations: any) => {
      if (translations && typeof translations === 'object') {
        this.primeNG.setTranslation(translations)
      }
    })
  }
}
